import { Breadcrumb, BreadcrumbItem } from "reactstrap";

function BreadcrumbComponent(props) {
    return (
        <Breadcrumb listTag="div" className="ps-2">
            {props.path.map((path, key) => {
                if(path.href !== "")
                    return (
                        <BreadcrumbItem href={path.href} tag="a" >{path.value}</BreadcrumbItem>
                    );
                return (<BreadcrumbItem active tag="span">{path.value}</BreadcrumbItem>)
            })}
        </Breadcrumb>
    );
}

export default BreadcrumbComponent;